const initialState = {
  programGroups: [],
  pathwayLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'POPULATE_PATHWAY_SLOTS': {
      return {
        ...state,
        programGroups: action.programSlots.programGroups,
      };
    }
    case 'PATHWAY_SELECTION.POPULATE_PATHWAY_LOADING': {
      return {
        ...state,
        pathwayLoading: action.status,
      };
    }
    default:
      return state;
  }
};
